import React, { useState, useEffect } from 'react';
import PageContainerWithLogo from '../Core/PageContainerWithLogo';
import '../../css/faq.css';

const FAQ = () =>
{
  const [ activeSection, setActiveSection ] = useState( '' );

  const faqItems = [
    {
      id: 'karma',
      question: 'What is "Karma" about?',
      answer: 'Karma is earned when you complete any Tilefolk game against other humans. You lose that karma point if you quit the game early and do not come back. The Karma system is there to help discourage players from abandoning games mid-way through, which isn\'t fun for the other players. Your Karma score is a rolling tally from the last 20 played games. If a game host is looking to put together a new game, and someone joins the room with a low Karma score, this player will be seen as unreliable, and might get kicked out by the host.'
    },
    {
      id: 'copyright',
      question: 'I\'m worried about Tilefolk.io from a copyright standpoint. What assurances do I have about this?',
      answer: 'Game mechanics can not be copyrighted. We own all of our assets & codebase. Tilefolk has no copyright issues.'
    }
  ];

  useEffect( () =>
  {
    const handleScroll = () =>
    {
      const sections = faqItems.map( item => document.getElementById( item.id ) );
      const scrollPosition = window.scrollY + 100;

      for( let i = sections.length - 1; i >= 0; i-- )
      {
        const section = sections[ i ];
        if( section && section.offsetTop <= scrollPosition )
        {
          setActiveSection( faqItems[ i ].id );
          break;
        }
      }
    };

    window.addEventListener( 'scroll', handleScroll );
    return () => window.removeEventListener( 'scroll', handleScroll );
  }, [] );

  const scrollToSection = ( id ) =>
  {
    const element = document.getElementById( id );
    if( element )
    {
      element.scrollIntoView( { behavior: 'smooth' } );
    }
  };

  return (
    <PageContainerWithLogo>
      <div className="faq-page">
        <div className="faq-sidebar">
          <div className="faq-sidebar-header">
            <h3>Quick Links</h3>
          </div>
          <ul className="faq-nav-list">
            { faqItems.map( ( item ) => (
              <li key={ item.id }>
                <a
                  href={ `#${item.id}` }
                  className={ `faq-nav-link ${activeSection === item.id ? 'active' : ''}` }
                  onClick={ ( e ) =>
                  {
                    e.preventDefault();
                    scrollToSection( item.id );
                  } }
                >
                  { item.question }
                </a>
              </li>
            ) ) }
          </ul>
        </div>

        <div className="faq-content">
          <header className="faq-header">
            <h1>Frequently Asked Questions</h1>
            <p>Find answers to common questions about Tilefolk.io</p>
          </header>

          <div className="faq-sections">
            { faqItems.map( ( item ) => (
              <section key={ item.id } id={ item.id } className="faq-item">
                <h2 className="faq-question">{ item.question }</h2>
                <div className="faq-answer">
                  <p>{ item.answer }</p>
                </div>
              </section>
            ) ) }
          </div>
        </div>
      </div>
    </PageContainerWithLogo>
  );
};

export default FAQ;
